if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.announcement__slider');
      this.slides = this.slider ? this.slider.querySelectorAll('.announcement__slide') : [];
      this.isPaused = false;
      this.currentIndex = 0;

      if (this.slides.length > 1) {
        this.bindEvents();
        this.init();
      }
    }

    bindEvents() {
      if (this.slider) {
        this.slider.addEventListener('mouseenter', () => { this.isPaused = true; });
        this.slider.addEventListener('mouseleave', () => { this.isPaused = false; });
      }
    }

    init() {
      const delay = parseInt(this.dataset.slideDelay) || 5000;

      const tick = () => {
        // Only auto-rotate while the bar is a carousel (below 1024px)
        if (!this.isPaused && !this.isDesktop() && this.isInViewport()) {
          this.nextSlide();
        }
        setTimeout(tick, delay);
      };

      setTimeout(tick, delay);
    }

    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      const target = this.slides[this.currentIndex];

      if (document.dir === 'rtl') {
        this.slider.scrollTo({
          left: -Math.abs(target.offsetLeft),
          behavior: 'smooth'
        });
      } else {
        this.slider.scrollTo({
          left: target.offsetLeft,
          behavior: 'smooth'
        });
      }
    }

    isDesktop() {
      // Must match the breakpoint where announcement.css switches from the
      // carousel to the static row of items.
      return window.matchMedia('(min-width: 1024px)').matches;
    }

    isInViewport() {
      if (typeof theme !== 'undefined' && theme.elementUtil && theme.elementUtil.isInViewport) {
        return theme.elementUtil.isInViewport(this);
      }
      var rect = this.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
